function objectifyPipelineStatus(data) {
  return data.reduce(
    (newData, item) => ({
      ...newData,
      [item.id]: item.pipelineStatus,
    }),
    {},
  )
}

function statusDiff(newTuples, oldTuples) {
  const diff = {}

  for (const key in newTuples) {
    if (newTuples[key] !== oldTuples[key]) {
      diff[key] = {
        newValue: newTuples[key],
        oldValue: oldTuples[key] || '',
      }
    }
  }

  return diff
}

function changedContractStatus(diff) {
  return Object.keys(diff).filter(key => {
    const { oldValue, newValue } = diff[key]
    return oldValue !== '' && newValue === 'Contrato Novo'
  })
}

export { objectifyPipelineStatus, statusDiff, changedContractStatus }
